// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"2c81375f42e16707","888":"21e0d08759d5598f"}[chunkId] + ".css";
};